module.exports = __webpack_public_path__ + "img/shopping-code.78dc2c71.jpg";